import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import styles from "../loginErrorModal/ErrorModal.module.scss";

var YesNoModal = function YesNoModal(props) {
  var toggle = props.toggle,
      show = props.show,
      redirect = props.redirect;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(Modal, {
      isOpen: show,
      toggle: toggle,
      style: {
        fontFamily: isRTL ? 'Yekan' : 'Helvetica'
      },
      children: [/*#__PURE__*/_jsx(ModalBody, {
        children: isRTL ? 'توکن جلسه شما منقضی شده، لطفا دوباره وارد شوید و امتحان کنید' : 'Your login session has expired, please login and try again'
      }), /*#__PURE__*/_jsx(ModalFooter, {
        children: /*#__PURE__*/_jsx(Link, {
          href: {
            pathname: '/verifyPhone',
            query: {
              redirect: redirect
            }
          },
          children: /*#__PURE__*/_jsx("a", {
            className: "btn bg-primary ".concat(styles.loginBtn),
            children: isRTL ? 'ورود یا ثبت نام' : 'Login or Register'
          })
        })
      })]
    })
  });
};

export default YesNoModal;